<main class="container  hide-scrollbar">
    <div id="containerLeftMenu" style="margin-right: 15px">  
        <left-menu [showImportExport]="false"/>
     </div> 
    <section id="column2">
        <div class="row">
            <div class="col col-12">
                <!-- <h2>Chevron Fitness-for-Service Level 1 Application (FFS Level 1)
                </h2> -->

                <div style="background-color: white; width:100%">
<html>
<head>
<style>
table, th, td {
  border: 1px solid black;
  /* border-collapse: collapse; */
  background-color: white;
 
              }

th {
  text-align: left;
}
body {
  /* Hide scrollbars */
  overflow-y: hidden;
}



</style>

</head>
<body>
<table style="width:100%" >
 <tr><th colspan="3" text-align="centre">Chevron Fitness for Service Level 1 Application (FFS Level 1):</th></tr>
  <tr>
    <th>Release version</th>
    <th>Release date</th>
    <th>Comments / features released</th>
  </tr>
    <tr>
        <td>1.0.6.2</td>
        <td>Aug 06, 2026</td>
        <td>
                <ul>
                        <li><tr>The calculation of the Remaining Strength Factor (RSF) in the LML Module has been revised to ensure that the results are consistent with API 579 procedures.</tr></li>
                        <li><tr>The metal loss region in the LML Profile Module is now defined using the number of thickness readings and the spacing between readings. This change eliminates ambiguity in establishing the critical thickness profile length and number of thickness reading.</tr></li>
                </ul>
        </td>
    </tr>
   <tr>
    <td>1.0.6.1</td>
    <td>Jun 03, 2026</td>
    <td>
        <ul>
            <li><tr>This release includes fix For INC05453706</tr></li>
            <li><tr>The local Metal Loss profile module data input - Metal loss length in the axial direction is being used as spacing between data point and not as the total length which is not correct.</tr></li>
           
        </ul>
    </td>
  </tr>
   <tr>
    <td>1.0.6</td>
    <td>Apr 08, 2026</td>
    <td>
        <ul>
            <li><tr>This release includes updates to External Pressure calculations for the General Metal Loss (GML), Localized Metal Loss (LML), LML Profile, and Gouges assessment modules.</tr></li>
            <li><tr>When changing to a different assessment module, the user is now required to select "New Analysis" first. Previously, partial data could remain in application memory when switching modules directly. This change prevents data carryover between modules.</tr></li>
            <li><tr>For the GML Module, the screen for selecting External or Internal pressure has been removed when the component type "Sphere" is selected, as there is currently no external pressure calculation module for a sphere.</tr></li>
        </ul>
    </td>
  </tr>
   <tr>
    <td>1.0.5</td>
    <td>Feb 02, 2026</td>
    <td>
        <ul>
            <li><tr>This release implements External Pressure Calculation capability for cylindrical components within the General Metal Loss (GML) assessment module. The new functionality enables evaluation of external instability limits in accordance with the applicable design and Fitness‑for‑Service criteria.
Additionally, this release fixed several data-loss issues found in some assessment modules when loading or restoring saved assessment files.</tr>      
        </ul>
    </td>
  </tr>
  <tr>
    <td>1.0.4</td>
    <td>Nov 10, 2025</td>
    <td>
        <ul>
            <li><tr>Add this comment /features released: Two additional Pipeline components (ASMEB31.4 and B31.8) are included in the Maximum Allowable Working Pressure (MAWP) Calculation Unit of all  assessment modules.</tr>      
        </ul>
     </td>
  </tr>
   <tr>
    <td>1.0.3</td>
    <td>April 15, 2025</td>
    <td>
        <ul>
            <li><tr>Addition of Type A Component screening for all the modules. This change will reduce the likelihood of human error and expedites the overall FFS Level 1 assessment reducing the time for doing this verification externally.</tr>      
        </ul>
     </td>
  </tr>
  <tr>
    <td>1.0.2</td>
    <td>Oct 07, 2024</td>
    <td>
        <ul>
            <li><tr>Changes in conditional checks and validations in LTA and Gouge modules.</tr>         
            <li><tr>Changes in the MAWP module when the Component selection type is F&D head.</tr></li>
            <li><tr>Changes in GML/MAWP screens/GOUGE module.</tr></li>          
        </ul>
     </td>
  </tr>
  <tr>
    <td>1.0.1</td>
    <td>Jul 25, 2024</td>
    <td>
        <ul>
            <li><tr>Change on the allowable stress SI units for consistency with API standard</tr>         
            <li><tr>Minor editorial changes in the Gouge Module.</tr></li>
            <li><tr>The 2s x 2c box check box was removed on Modules where this check is not applicable.</tr></li>
            <li><tr>-	The MAWPr result display was revised according to the results in the Metal Loss Modules.</tr></li>            
        </ul>
     </td>
  </tr>
  <tr>
    <td>1.0.0</td>
    <td>May 22, 2024</td>
    <td>
        <ul>
            <li><tr>Revision of result message display for Blister, HIC, and Crack-like Indication modules.</tr>         
            <li><tr>Optimization of data input by removing the allowable stress input from the Material Data screen since this datum was duplicated.</tr></li>
            <li><tr>Changes in the MAWP module when the Component selection type is 2:1 Elliptical Head.</tr></li>
            <li><tr>Update of Applicability and Limitations heading and Help menu content.</tr></li>
            <li><tr>Minor editorial changes and bugs correction from original version.</tr></li> 
        </ul>
     </td>
  </tr>
</table>

</body>
</html>
                </div>
            </div>
        </div>
    </section>
</main>
